import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class ProductIngredientsCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * slider element.
    **/
    constructor(sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.context = this.sliderElement.closest('.js-pdp-ingredients-carousel-context');
        this.arrowNext = this.context.querySelector('.swiper-button-next');
        this.arrowPrev = this.context.querySelector('.swiper-button-prev');
        this.scrollbar = this.context.querySelector('.swiper-scrollbar');

        this.init();
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 'auto',
            centerInsufficientSlides: true,
            spaceBetween: 20,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true
            },
            breakpoints: {
                1024: {
                    spaceBetween: 60
                }
            }
        });
    }
}
